import $ from 'gridstrap/lib/gs-zepto';
import { templates } from '.';

export class GSTemplate {

	private root;

	get id() { return this.root.data('gsTemplateId'); }
	get value() { return this.root.html().trim(); }
	get isAsync() { return !!this.asyncPath; }
	get asyncPath() { return this.root.data('gsTemplateAsync'); }

	constructor(root) {
		this.root = $(root);
	}

	private getTemplate(id) {
		$['ajax']({
			url: this.asyncPath,
			success: value => this.setTemplate(id, value)
		});
	}

	private setTemplate(id, value) {
		try {
			templates.set(id, value);
			this.root.remove();

			if ($('.gs-Template, .gs-Data').length === 0) {
				$('.gsc-data').removeClass('gsc-data').gs('gsOnDataReady');
				$('body').trigger('gs:dataAndTemplatesReady');
			}
		} catch(e) {
			console.log(`Error compiling template: ${id}`);
		}
	}

	gsOnInit() {
		this.isAsync
			? this.getTemplate(this.id)
			: this.setTemplate(this.id, this.value)
		;
	}

}
